// src/components/Sidebar.tsx
import React, { useEffect, useState } from "react";
import { URL_SERVER } from "../utils/Utils";
import FolderNode from "./FolderNode";
import dashboard from "../styles/dashboard.module.css";
import { AppThemeProvider, useTheme } from "../context/AppThemeContext";
import "../styles/global.css";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";


export type Folder = {
  id: number;
  name: string;
  children: Folder[];
};

type SidebarProps = {
  token: string | null;
  isAdmin: boolean;
  goToAdmin: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ token, isAdmin, goToAdmin }) => {
  const [unidadOpen, setUnidadOpen] = useState(true);
  const [folderData, setFolderData] = useState<Folder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { isNight } = useTheme();

  const transformFolder = (folder: any): Folder => ({
    id: folder.id,
    name: folder.name,
    children: folder.folders?.map(transformFolder) || [],
  });

  useEffect(() => {
    const fetchFolders = async () => {
      try {
        const response = await fetch(`${URL_SERVER}/${isAdmin ? 'v3' : 'v2'}/folders/root`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });


        const result = await response.json();
        if (!result.data) throw new Error("Error al cargar carpetas");
        const transformed = result.data.map(transformFolder);
        setFolderData(transformed);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFolders();
  }, []);

  const renderFolders = (folders: Folder[]) => (
    <ul>
      {folders.map((folder, index) => (
        <FolderNode key={index} folder={folder} level={1} />
      ))}
    </ul>
  );

  return (
    <div className={`${dashboard.folderNavigation} TituloMiUnidad`}>
      <span className={dashboard.horizontalSeparator}></span>

      <button
        onClick={() => setUnidadOpen(!unidadOpen)}
        className={`${dashboard.folderToggle} TituloMiUnidad`}

      >
          <span className={dashboard.arrowFolder}>
            {unidadOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
          </span>


        Mi unidad
      </button>

      {unidadOpen && (
        <>
          {loading ? <p>Cargando...</p> : renderFolders(folderData)}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </>
      )}
    </div>
  );
};

export default Sidebar;
